export default "__VITE_ASSET__CB$rQFHQ__"